// extracted by mini-css-extract-plugin
export default {"HiringPipelineValue":"styles_HiringPipelineValue__lw-+N"};